import { render, staticRenderFns } from "./billRatioSetting.vue?vue&type=template&id=68643a44&scoped=true"
import script from "./billRatioSetting.vue?vue&type=script&lang=js"
export * from "./billRatioSetting.vue?vue&type=script&lang=js"
import style0 from "./billRatioSetting.vue?vue&type=style&index=0&id=68643a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68643a44",
  null
  
)

export default component.exports